import { render, staticRenderFns } from "./TurnoverStaffCard.vue?vue&type=template&id=eecf8780&"
import script from "./TurnoverStaffCard.vue?vue&type=script&lang=js&"
export * from "./TurnoverStaffCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports